import * as React from "react";
import { getMobileDevice, isBrowser, labelToDashes } from "../../utils";
import { useMenu } from "../useMenu";
import { SHOW_APP_PROMOTION } from "../../constants/appPromotion";
import { AppStore } from "./AppStore";
import { PlayStore } from "./PlayStore";

export function StoreBlock() {
  const [appStore, playStore] = useMenu().items.stores;
  const { label: appCta } = useMenu().items.appCta;

  if (!isBrowser()) return null;

  // D-68: apps unavailable pending the store relaunch (D-20).
  if (!SHOW_APP_PROMOTION) return null;

  const { isIOS, isAndroid } = getMobileDevice(navigator);

  return (
    <div className={`md:elm-hidden elm-p-4 elm-bg-dd-green-100 elm-rounded-lg elm-mt-7`}>
      <div className="elm-text-xl elm-font-semibold elm-text-center elm-mb-2">{appCta}</div>
      <div className="elm-flex elm-justify-center">
        <div className="elm-w-36">
          <a
            className={`${isIOS ? "" : "elm-hidden"} elm-cursor-pointer elm-pointer-events-auto`}
            aria-label={appStore.label}
            data-track-label={labelToDashes(appStore.label)}
            href={appStore.href}
            target="_blank"
            rel="noopener"
          >
            <AppStore />
          </a>
          <a
            className={`${
              isAndroid ? "" : "elm-hidden"
            } elm-cursor-pointer elm-pointer-events-auto`}
            aria-label={playStore.label}
            data-track-label={labelToDashes(playStore.label)}
            href={playStore.href}
            target="_blank"
            rel="noopener"
          >
            <PlayStore />
          </a>
        </div>
      </div>
    </div>
  );
}
